const translations = {
  common: {
    yes: '是',
    no: '否',
    submit: '提交',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    next: '下一步',
    back: '返回'
  },
  nav: {
    previous: '上一步',
    next: '下一步',
    seeResults: '查看结果',
    of: '/',
    startOver: '重新开始',
    dashboard: '仪表板',
    backToHome: '返回首页'
  },
  index: {
    title: '项目情感价值评估',
    description: '利用BEAM专有的诊断平台评估净情感价值(NEV)并确定您的项目或组织的情感投资回报率(EROI)。',
    startButton: '开始评估',
    aboutLink: '了解更多',
    heroTitle: '释放情感连接的力量',
    heroSubtitle: 'BEAMEvaluate Lite - 为您的项目或业务提供净情感价值(NEV)/情感投资回报率(EROI)评估工具。',
    keyBenefitsTitle: '主要优势',
    keyBenefit1: '了解您项目的情感影响',
    keyBenefit2: '确定需要改进的领域',
    keyBenefit3: '与行业领导者进行对标',
    keyBenefit1Description: '发现您的品牌如何在情感上与受众产生共鸣，以及它在NEV量表上的表现。',
    keyBenefit2Description: '获取数据驱动的洞察，了解品牌可以建立更强情感连接的具体领域。',
    keyBenefit3Description: '将您的情感表现指标与行业标准和领先竞争对手进行比较。',
    testimonialsTitle: '客户评价',
    testimonial1: '这项评估为我们提供了可行的见解，以加强客户关系。',
    testimonial2: '实施推荐的变更后，我们看到客户忠诚度显著提高。',
    footer: '© 2025 BaaBaa情感资产管理集团。保留所有权利。',
    whyBeamevaluate: '为什么选择BEAMEvaluate',
    whyDescription: '初创企业面临着独特的挑战：平衡快速增长与情感和运营弹性。传统指标如NPS、CSAT和财务KPI往往无法捕捉到对长期成功至关重要的情感动态和伦理对齐。BEAM Evaluate LITE弥补了这一差距，提供了一个轻量级、可扩展且经过科学验证的框架来评估初创企业的健康状况。',
    beyondGrowthMetrics: '超越增长指标',
    beyondGrowthDesc: '衡量情感联系和可持续性，超越传统增长KPI',
    emotionalIntelligence: '情感智能',
    emotionalIntelligenceDesc: '捕捉对长期利益相关者关系至关重要的定性情感动态',
    scientificValidation: '科学验证',
    scientificValidationDesc: '利用经过科学验证的框架量化情感和伦理指标',
    holisticAssessment: '整体评估',
    holisticAssessmentDesc: '评估即时情感影响和长期可持续性因素',
    whyBeamevaluateButton: '为什么选择BEAMEvaluate',
    methodologyButton: 'BEAM方法论'
  },
  step: {
    1: '步骤 1',
    2: '步骤 2',
    3: '步骤 3',
  },
  industry: {
    title: "请选择行业",
    subtitle: "选择最能代表您项目的行业",
    choose: "选择行业",
    technology: "科技",
    healthcare: "医疗保健",
    finance: "金融",
    education: "教育",
    retail: "零售",
    manufacturing: "制造业",
    energy: "能源",
    entertainment: "娱乐",
    hospitality: "酒店业",
    food_beverages: "餐饮业",
    web_30fintech: "Web 3.0 & 金融科技",
    other: "其他",
    pageTitle: "项目信息",
    pageSubtitle: "输入项目详细信息以开始NEV/EROI评估",
    detailsTitle: "项目详细信息",
    projectName: "项目或企业名称",
    projectNamePlaceholder: "输入您的项目或企业名称",
    continue: "继续进行调查",
    assessmentInfo: "BEAMEvaluate Lite评估包含在三个维度上的19个问题。",
    selectRequired: "请选择一个行业以继续",
    nameRequired: "请输入项目名称以继续",
    technology_guidance: "在科技行业，请考虑创新周期、用户体验设计、德技术��践。",
    healthcare_guidance: "在医疗保健行业，患者成果、医疗可及性和对提供者的信任是关键考虑因素。",
    finance_guidance: "对于金融服务，请考虑透明度、安全性以及如何建立客户信心。",
    education_guidance: "在教育领域，学习成果、可及性和社区建设是重要因素。",
  },
  app: {
    start: '开始评估',
    methodology: 'BEAM评估方法',
    beamMethodology: 'BEAM评估方法',
    tagline: '利用BEAM专有的诊断平台评估净情感价值(NEV)并确定您的项目或组织的情感投资回报率(EROI)。',
    copyright: '© 2025 BaaBaa情感资产管理集团。保留所有权利',
    close: '关闭'
  },
  pdf: {
    project: '项目名称:',
    industry: '行业:',
    title: 'BEAMEvaluate NEV评估报告',
    generated: '生成日期',
    nev: 'NEV得分',
    eroi: '情感投资回报率',
    rating: '评级',
    percentile: '行业百分位',
    insight: '关键洞察',
    breakdown: '维度分析',
    recommendations: '重点建议',
    risk: '风险评估',
    bright: '亮点及风险警示',
    'bright.spots': '亮点',
    'red.flags': '风险警示',
    contact: '联系我们',
    waitlist: '加入BEAMEvaluate Pro版本等待名单:',
    email: '电子邮件: jc@baabaa.com',
    website: '网站: www.baabaa.io',
    copyright: '© 2025 BaaBaa情感资产管理集团。保留所有权利',
    page: '页码',
    'dimension.ea': '情感依恋 (EA)',
    'dimension.elv': '伦理遗产价值 (ELV)',
    'dimension.l': '长久性 (L)',
    community: '社区',
    ethics: '伦理标准',
    funding: '资金',
    innovation: '创新',
    disclaimer: '免责声明: 本报告仅供评估目的使用，不构成投资建议。结果应与您自己的财务评估结合使用。',
    'pro.title': 'BEAMEvaluate Pro版本包含',
    'pro.description': 'BEAMEvaluate Pro版本提供全面的AI驱动分析与区块链智能集成，为您项目的情感价值提供更深入的洞察。Pro版本包括详细的竞争对标、风险分层和基于高级算法的可行性策略建议。Pro版本利用区块链数据验证社区参与度、情感分析和市场定位，提供更高精度的决策支持。',
    metrics: '指标表现',
    'risk.title': '风险评估',
    emotional: '情感依恋',
    legacy: '伦理遗产价值',
    longevity: '长久性',
    trust: '信任建设',
    behavioral: '行为连续性',
    score: '得分',
    'industry.avg': '行业平均',
    diff: '差异',
    sentiment: '情感分析',
    'dominant.emotions': '主要情感'
  },
  results: {
    title: 'BEAMEvaluate - 评估报告',
    subtitle: '这是您的评估结果',
    emotionalAttachment: '情感依恋',
    ethicalValue: '伦理价值',
    longTermValue: '长期价值',
    trustAndBelief: '信任与信念',
    businessContinuity: '业务连续性',
    emotionalAttachmentDescription: '衡量用户情感连接、项目忠诚度和社区参与度的强度',
    ethicalValueDescription: '评估变革性影响、长期行业相关性和遗产价值',
    longTermValueDescription: '分析摩擦点和参与障碍（越低越好）',
    trustAndBeliefDescription: '衡量在兑现承诺方面的可信度、透明度和一致性',
    businessContinuityDescription: '评估转化为有形行动，如投资或倡导',
    download: '下载PDF',
    nev: 'NEV分数',
    eroi: 'EROI',
    back: '返回',
    generating: '生成中',
    exporting: '导出中',
    pdf: '导出PDF',
    csv: '导出CSV',
    in: '-',
    standard: '标准视图',
    professional: '专业仪表板',
    predictive: '预测',
    ai: 'AI分析',
    nevScore: '净情感价值(NEV)分数',
    rating: '评级',
    recommendations: '主要建议',
    keyInsight: '关键洞察',
    saved: '结果已保存',
    savedDesc: '您的评估结果已保存到您的账户。',
    error: '错误',
    noData: '无法找到调查数据',
    saveError: '����存��误',
    saveErrorDesc: '保存结果时出错',
    backToDashboard: '返回仪表板',
    performanceAnalysis: '绩效分析',
    riskAssessment: '风险评估',
    industryBenchmarking: '行业对标分析',
    recommendationsTitle: '建议',
    understandingBeamScore: "**BEAM评分**在0-10分范围内衡量跨不同资产类别的情感和战略价值。高分（8-10分）表示卓越的情感共鸣、强有力的伦理契合度和高度的适应潜力。低分（0-3分）表明需要在利益相关者参与和战略定位方面立即改进。",
    applicationTitle: "**BEAM评分应用：**",
    industryStandards: "跨资产类别和行业比较表现",
    improvementOpportunities: "识别情感和战略价值提升的具体领域",
    trackProgress: "监测情感连接和战略定位的长期改进",
    compareProjects: "与行业领导者和竞争对手进行对标",
    measureROI: "量化情感和战略投资回报",
    noDataDownload: '没有可用数据可供下载',
    errorDesc: '获取数据时出错',
    categoryDistribution: '类别分布',
    metricsBreakdown: '指标详解',
    topRecommendations: '重点建议',
    loading: '加载您的结果...',
    backToSurvey: '返回调查',
    legacyValueIndicators: '遗产价值指标',
    riskAssessmentChart: '风险评估图表',
    basicView: '基础视图',
    advancedView: '高级视图',
    beamAIInsights: 'BEAM AI洞察',
    beamMethodology: 'BEAM方法论',
    beamEvaluateAnalysis: 'BEAMEvaluate分析',
    eroiValue: 'EROI价值',
    recommendationHighPriority: '这条高优先级建议针对您项目情感价值的最关键方面。实施这一行动将产生最高的情感投资回报。',
    recommendationMediumPriority: '这条建议专注于能显著增强您项目与受众之间联系的重要方面。',
    recommendationLowPriority: '这条建议提供了额外价值，建议在解决更高优先级项目后考虑。',
  },
  survey: {
    title: 'BEAMEvaluate Lite',
    manual: '分步',
    ai: {
      guide: 'AI 方法指南',
      thinking: 'AI正在思考...',
      applied: '已应用AI建议',
      description: 'AI已为所有问题生成指导。您现在可以查看和编辑回应。',
      chat: {
        welcome: '我是BEAM的AI代理 - BEAMER。欢迎参加我们的调查。我将逐一引导您回答问题，并提供方法建议，帮助您创建周到的回应。',
        complete: '感谢您完成所有问题！我现在正在准备您的结果...'
      },
      methodology: {
        description: 'BEAM 评估框架指南提供专业洞见，帮助您制定深思熟虑的回应。每个建议都基于行业特定的最佳实践和面向未来的策略考虑。'
      },
      guidance: {
        consider: '考虑',
        in: '在',
        industry: '行业中如何解决这个问题',
        failed: '指导生成失败',
        error: '发生错误',
        help: '查看每个问题的指导以帮助制定您的回应'
      },
      guidanceText: '查看每个问题的指导以帮助制定您的回应',
      guideDescription: '使用AI获取每个问题的方法指导',
      guideInstruction: '描述您的项目以获取所有问题的AI支持指导',
      howThisWorks: '这是如何运作的',
      methodologyGuide: 'BEAM AI方法论指南能够根据您的行业和项目类型提供定制化建议。它利用行业专家和情感价值研究来生成相关指导。',
      howToUse: '如何使用此工具',
      useInstructions: '1. 简要描述您的项目\n2. AI将根据您的行业和项目创建定制指导\n3. 使用这些建议来完成调查问题'
    },
    chat: {
      title: 'BEAM AI调查',
    },
    data: {
      local: '所有数据都存储在本地，不会发送到任何服务器。',
    },
    platform: {
      info: '本平台由BaaBaa情感资产管理集团提供支持。请勿上传敏感数据。',
    },
    text: {
      explanation: '解��',
      current: '�������数',
      instructions: '至少 5 字',
      placeholder: '在此输入您的回复...',
      defaultPlaceholder: '在此输入您的答案...',
      seeExample: '查看示例',
      example: '例子',
      guidance: '写作指导',
      guidanceTooltip: '在您的回应中提供具体例子并尽可能详细。',
      minWords: '请至少提供 5 个字以进行有意义的回应。',
      required: '需要 5 个字',
      prompts: '\n\n考虑这些提示来完善您的回答：\n• 您的项目中有哪些具体例子展示了这一点？\n• 这与行业标准相比如何？\n• 有哪些可衡���的成果支持您的评估？',
    },
    likert: {
      1: '非常不同意',
      2: '不同意',
      3: '中立',
      4: '同意',
      5: '非常同意',
    },
    rating: '评分',
    dropdown: {
      placeholder: '选择一个选项',
    },
    help: '帮助',
    unsupported: '不支持的问题类型',
    project: {
      description: '项目描述'
    },
    describe: {
      placeholder: '例如："我们的软件平台通过AI驱动的调度和通信工具帮助医疗服务提供者简化患者护理协调，目标客户为北美的中型诊所和医院。"',
    },
    generating: {
      guidance: '正在生成指导'
    },
    question: {
      guidance: '问题指导'
    },
    no: {
      specific: {
        guidance: '本问题没有具体指导'
      }
    },
    processing: '处理中...',
    generateGuidance: '生成指导',
    methodology: '方法论',
    methodology_bc: '行为转化指标',
    answer: {
      required: '需要回答'
    },
    more: {
      detail: '请完成所有必需的问题再继续。'
    },
    generate: {
      guidance: '生成指导'
    }
  },
  chart: {
    sensitivityAnalysis: 'BEAM敏感性分析',
    sentimentAnalysis: '情感分析警报',
    frictionAlert: '摩擦警报',
    dominantEmotions: '检测到的主要情感',
    needsImprovement: '需要改进',
    moderateReturn: '适中回报',
    strongReturn: '强烈回报',
    showBeamAI: '显示BEAMEvaluate AI分析',
    hideBeamAI: '隐藏BEAMEvaluate AI分析',
    projectSensitivity: 'BEAM敏感性分析'
  },
  dashboard: {
    title: '您的仪表板',
    subtitle: '查看和管理您已保存的项目评估',
    savedAssessments: '已保存的评估',
    newAssessment: '新评估',
    noSavedAssessments: '您还没有任何已保存的评估。',
    startFirst: '开始您的首次评估',
    date: '日期',
    delete: '删除',
    view: '查看',
    confirmDelete: '您确定要删除此评估吗？',
    deleted: '评估已删除',
    deletedDesc: '评估已成功删除。',
    deleteError: '删除错误',
    deleteErrorDesc: '删除评估时发生错误。',
    loadError: '加载错误',
    loadErrorDesc: '加载评估时发生错误。'
  },
  auth: {
    title: '欢迎使用BEAMEvaluate',
    subtitle: '评估您项目的情感价值',
    login: '登录',
    loginDesc: '登录您的账户',
    registerDesc: '创建新账户',
    email: '电子邮件',
    password: '密码',
    fullName: '全名',
    loginButton: '登录',
    registerButton: '注册',
    back: '返回首页',
    register: '注册',
    required: '需要认证',
    requiredDesc: '请登录或注册以保存您的结果。'
  },
  metrics: {
    emotional: '情感参与',
    legacy: '遗产价值',
    longevity: '长久性',
    friction: '摩擦系数',
    trust: '信任指标',
    continuity: '连续性',
    category: '类别',
    title: '指标说明',
    nev: "净情感价值(NEV)",
    nev_description: "一个全面的0-50分数，衡量项目的整体情感和战略价值。NEV整合了情感依恋、伦理遗产、信任和长期潜力等多个维度。",
    beamScore: "BEAM评分",
    beamScore_description: "一个精炼的0-100指数，将复杂的情感和战略指标浓缩为单一、可操作的绩效指标。该分数综合了情感智能、伦理契合度、创新潜力和利益相关者共鸣。",
    eroi: "情感投资回报率 (EROI)",
    eroi_description: "一个衡量情感投资如何有效转化为资产或项目有形价值创造的乘数。该指标有助于基于当前情感参与水平预测未来表现。",
  },
  methodology: {
    title: 'BEAM评估方法',
    subtitle: '了解我们如何评估您项目的情感连接',
    description: 'BEAM的方法论基于情感营销和品牌依附理论的科学研究。我们通过一系列有针对性的问题分析您的项目如何与用户建立有意义的连接。',
    ea: {
      title: '情感依恋 (EA)',
      description: '衡量用户情感连接、项目忠诚度和社区参与度的强度',
      metric1: '情感共鸣强度',
      metric2: '项目依附深度指数',
      metric3: '用户忠诚度潜力评级',
      metric4: '信任、透明度和承诺履行评估',
      guidance: '思考用户如何与您的项目形成情感联系。考虑项目认知度、用户社区和个人依附。您的项目如何创建有意义的关系？'
    },
    elv: {
      title: '伦理遗产价值 (ELV)',
      description: '评估变革性影响和行业长期相关性',
      metric1: '社会影响因素',
      metric2: '变革潜力',
      metric3: '行业叙事影响',
      guidance: '考虑项目的持久影响和伦理基础。它代表什么价值观？它如何对社会或行业做出积极贡献？'
    },
    l: {
      title: '长久性 (L)',
      description: '衡量参与障碍（越低越好）',
      metric1: '摩擦点分析',
      metric2: '参与障碍计数',
      guidance: '反思可持续性和韧性因素。您的项目如何适应变化？什么确保了它的长期相关性？'
    },
    tb: {
      guidance: '关注建立信任的要素。什么使利益相关者相信您的项目？您如何建立和维持信誉？'
    },
    default: {
      guidance: '考虑与此问题相关的项目特定特征。'
    },
    eroi: {
      title: '情感投资回报率 (EROI)',
      description: '我们计算情感资产投资回报率的专有公式将定量指标与定性分析相结合。',
      formula: 'EROI公式: EROI = 净情感价值 × 行为转化 ÷ 摩擦系数',
      formula_text: 'EROI = NEV × BC ÷ FC',
      component1: '净情感价值 - EA、ELV和其他指标的综合评分',
      component2: '衡量情感如何转化为有形行动',
      component3: '量化参与障碍（越低越好）',
      interpretation: 'EROI解释量表:',
      interpretation1: '<0.8: 需要改进 - 情感投资未产生足够回报',
      interpretation2: '0.8-1.5: 适中回报 - 积极但存在优化机会',
      interpretation3: '>1.5: 强烈回报 - 出色的情感ROI，具有高转化潜力'
    },
    differentiators: {
      title: "BEAMEvaluate的差异化因素",
      description: "是什么使BEAM的方法区别于传统评估框架:",
      key: "关键差异化因素",
      factor1: {
        title: "以情感为中心的分析",
        description: "优先考虑情感连接而非传统指标"
      },
      factor2: {
        title: "专有算法",
        description: "基于广泛行业数据集训练的定制开发分析模型"
      },
      factor3: {
        title: "跨行业适用性",
        description: "适用于各种不同行业的适应性框架"
      },
      factor4: {
        title: "可行的见解",
        description: "优化情感ROI的明确建议"
      }
    },
    nev: {
      title: "净情感价值 (NEV)",
      description: "一个全面的0-50分数，衡量情感和战略价值",
      calculation: 'NEV计算框架和理论依据',
      formula: 'NEV = (情感依恋 × 0.40) + (伦理遗产 × 0.35) + (长久性 × 0.25)',
      explanation: '这个平衡公���将情感依恋权重最高(40%)作为价值创造的基础，其次是伦理遗��价值(35%)以确保可持续性，以及影响采用和保���的长久���因素(25%)。'
    },
    risk: {
      high: {
        label: '高风险',
        points: '<60分'
      },
      competitive: {
        label: '具竞争力',
        points: '60-80分'
      },
      exceptional: {
        label: '卓越',
        points: '>80分'
      }
    },
    beamScore: {
      title: "BEAM评分解析",
      overview: "BEAM评分是一种专有的多维绩效指标，将复杂的项目动态转化为直观的0-100量表。",
      components: [
        "情感智能：衡量用户连接深度和社区参与度",
        "伦理一致性：评估项目对社会和行业的长期影响",
        "创新潜力：评估适应性和变革能力",
        "利益相关者共鸣：衡量信任度、可信度和感知价值"
      ],
      interpretationScale: {
        low: "0-30：需要重大改进。建议进行根本性重组。",
        medium: "40-70：竞争性表现，具有明确的增长机会。",
        high: "80-100：卓越的战略定位，具有强大的情感和创新领导力。"
      }
    }
  },
  risk: {
    highrisk: '高风险',
    competitive: '竞争力',
    exceptional: '卓越',
  },
  recommendations: {
    emotionalConnection: '通过个性化互动加强与客户的情感连接',
    communityBuilding: '创建社区建设计划以促进更深入的依附',
    innovationRate: '提高创新率以保持领先于竞争对手',
    switchingCosts: '提高转换成本以增加用户留存率',
    founderVisibility: '增加创始人在日常运营中的可见度',
    communication: '制定更清晰的长期愿景沟通',
    teamBuilding: '实施团队建设计划以改善协作',
    diversity: '创建多样性和包容性计划以加强团队动态'
  },
  ai: {
    insights: {
      title: 'BEAM AI洞察',
      description: 'AI驱动的项目情感和战略价值分析',
      beta: '测试版',
      noData: '无可用评分数据。请完成评估以查看AI洞察。'
    },
    sentiment: {
      analysis: '情感分析',
      score: '情感得分',
      positive: '在回应中检测到强烈正面情感',
      neutral: '回应中的情感为中性至正面',
      negative: '情感分析中发现关注领域',
      emotions: '检测到的情感',
      keywords: '关键主题',
      distribution: '情感分布',
      confidence: 'AI置信度',
      high: {
        confidence: '基于详细回应的高置信度分析'
      },
      moderate: {
        confidence: '适中置信度 - 建议提供更多细节以提高准确性'
      },
      low: {
        confidence: '低置信度 - 可用于分析的回应数据有限'
      }
    },
    recommendations: {
      personalized: '行业专属建议',
      impact: '预期影响',
      high: '高',
      medium: '中等',
      moderate: '适中',
      insight: '行业洞察',
      based: {
        on: {
          industry: '这些建议根据当前市场趋势和您的评估结果针对您的行业进行了优化。'
        }
      }
    },
    prediction: {
      future: '表现预测',
      current: {
        nev: '当前NEV'
      },
      potential: {
        nev: '潜在未来NEV'
      },
      points: '分',
      timeline: '实施时间线',
      focus: {
        areas: '重点领域'
      },
      note: '预测说明',
      based: {
        on: '此预测基于对在建议领域实施有针对性改进的类似组织的统计分析。'
      }
    },
    competitive: {
      analysis: '竞争分析',
      position: '市场地位',
      based: {
        on: {
          industry: '基于您的NEV得分与行业平均水平的比较。'
        }
      },
      strengths: '竞争优势',
      weaknesses: '改进领域',
      opportunities: '战略机会'
    }
  },
  industrySelector: {
    title: '选择您的行业',
    description: '选择最能代表��业务的行业。',
    selectIndustry: '选择行业',
  },
  professionalDashboard: {
    performanceAnalysis: '绩效分析',
    riskAssessment: '风险评估',
    industryBenchmarking: '行业对标���析',
    recommendations: '建议',
    community: '社区参与',
    ethics: '伦理标准',
    funding: '资金况',
    innovation: '创新能力',
    keyInsight: '关键洞察',
    emotionalAnalysis: '情感分析',
    emotionDistribution: '情感分布',
    confidenceLevel: '置信水平',
    industrySpecificRecommendations: '行业专属建议',
    estimatedImpact: '预计影响',
    marketPosition: '市场地位',
    implementationTimeline: '实施时间线',
    focusAreas: '重点领域',
    predictionNote: '预测说明',
    strategicOpportunities: '战略机会',
    competitiveStrengths: '竞争优势',
    improvementAreas: '改进领域',
    legacyValueIndicators: '遗产价值指标',
    foundersCommitmentAlert: '检测到创始人承诺度问题。增加创始人参与度和可及性将加强整体价值。'
  },
  industries: {
    Technology: '科技',
    Finance: '金融',
    Healthcare: '医疗保健',
    Education: '教育',
    Retail: '零售',
    Manufacturing: '制造业',
    Energy: '能源',
    Entertainment: '娱乐',
    Hospitality: '酒店业',
    Food_Beverages: '餐饮业',
    Web_30fintech: 'Web 3.0 & 金融科技',
    Other: '其他',
  },
};

export default translations;
